import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { initialValues } from './formData';

import { Product } from '../../../../../shared/types/systemConfiguration/products';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../services/param.service';

export const useProductFilters = (onFilter?: (data: Product) => void) => {
    const [sfcCaptureUnit, setSfcCaptureUnit] = useState<ISelect[]>([]);
    const [sfcCaptureUnitNews, setSfcCaptureUnitNews] = useState<ISelect[]>([]);

    const onSubmit = (data: Product) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.SFC_CAPTURE_UNIT_NEW).then((items) =>
            setSfcCaptureUnitNews(items)
        );

        asyncGetParams(ParamEnum.SFC_CAPTURE_UNIT).then((items) =>
            setSfcCaptureUnit(items)
        );
    }, []);

    return {
        formik,
        sfcCaptureUnit,
        sfcCaptureUnitNews,
    };
};
